const config = process.env.APP_CONFIG

export default config
